/* eslint-disable @typescript-eslint/no-unused-vars */
/* Autogenerated, do not modify! */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import SvgIcon from '@move-ui/svg-icon';
export const SocialCircleTwitterIcon = (_a) => {
    var { fillColor = 'currentColor', strokeColor = 'currentColor' } = _a, svg = __rest(_a, ["fillColor", "strokeColor"]);
    return (React.createElement(SvgIcon, Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24", "data-icon": true }, svg),
        React.createElement("path", { fill: fillColor, fillRule: "evenodd", d: "M12 21a9 9 0 100-18 9 9 0 000 18z", clipRule: "evenodd" }),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M16 9.829a3.094 3.094 0 01-0.943 0.278 1.755 1.755 0 000.722-0.978 3.148 3.148 0 01-1.042 0.429A1.588 1.588 0 0013.539 9c-0.907 0-1.642 0.791-1.642 1.767a1.89 1.89 0 000.043 0.403c-1.364-0.074-2.574-0.777-3.383-1.847a1.864 1.864 0 00-0.222 0.889 1.806 1.806 0 000.73 1.47 1.543 1.543 0 01-0.744-0.22v0.022c0 0.856 0.566 1.57 1.317 1.732a1.526 1.526 0 01-0.741 0.031c0.209 0.702 0.815 1.213 1.533 1.227A3.148 3.148 0 018 15.206 4.406 4.406 0 0010.516 16c3.019 0 4.67-2.693 4.67-5.028a5.415 5.415 0 00-0.005-0.229A3.482 3.482 0 0016 9.83z", clipRule: "evenodd" })));
};
//# sourceMappingURL=SocialCircleTwitterIcon.js.map